export enum EnumDecontoOuAcrescimo {

    //DESCONTO/ACRESCIMO ITEM
    DescontoItem = 0,
    AcrescimoItem = 1,

    //DESCONTO/ACRESCIMO VENDA
    DescontoVenda = 2,
    AcrescimoVenda = 3,
}